import { FaSearch } from "react-icons/fa";
import { Container } from "./style";

interface IProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function InputBusca({ value, onChange, placeholder = "Buscar" }: IProps) {
  return (
    <Container>
      <FaSearch size={13} />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </Container>
  );
}
